// components/onboarding/AuthSidePanel.tsx
import Link from "next/link";
import Image from "next/image";
import { CheckCircle } from "lucide-react";

interface AuthSidePanelProps {
  headline: string;
  subline: string;
  features: string[];
}

export default function AuthSidePanel({ headline, subline, features }: AuthSidePanelProps) {
  return (
    <div className="relative hidden md:flex w-1/3 flex-col justify-between bg-[#002301] overflow-hidden px-8 py-10">
      {/* Dot pattern background */}
      <div className="absolute inset-0 pointer-events-none opacity-10">
        <svg width="100%" height="100%">
          <defs>
            <pattern id="auth-dots" width="28" height="28" patternUnits="userSpaceOnUse">
              <circle cx="1.5" cy="1.5" r="1.5" fill="#17BC2E" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#auth-dots)" />
        </svg>
      </div>

      {/* Glow blob */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-[#17BC2E]/10 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-[#FFB600]/8 rounded-full blur-3xl pointer-events-none" />

      {/* Logo */}
      <div className="relative z-10">
        <Link href="/">
          <Image src="/logo.png" alt="Ren Power Group" width={140} height={48} className="h-10 w-auto brightness-0 invert" />
        </Link>
      </div>

      {/* Main content */}
      <div className="relative z-10 space-y-6">
        <div>
          <h2 className="text-white font-bold text-3xl leading-snug mb-3">{headline}</h2>
          <p className="text-white/60 text-sm leading-relaxed">{subline}</p>
        </div>

        <ul className="space-y-3">
          {features.map((f) => (
            <li key={f} className="flex items-center gap-3">
              <CheckCircle className="w-4 h-4 text-[#FFB600] flex-shrink-0" />
              <span className="text-white/75 text-sm">{f}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* Footer */}
      <div className="relative z-10">
        <p className="text-white/30 text-xs">Nigeria's solar marketplace platform. Powering a greener future.</p>
      </div>
    </div>
  );
}
